import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { euro } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const loc = useLocation();
  const nav = useNavigate();
  const isCancel = loc.pathname.includes("/cancel");
  const sessionId = params.get("session_id");
  const [state, setState] = useState(isCancel ? "cancel" : "checking");
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (isCancel || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setAmount(data.amount_cents);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("failed"); return; }
      } catch (e) { /* keep polling */ }
      if (tries++ < 12) setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
  }, [sessionId, isCancel]);

  return (
    <div className="max-w-md mx-auto mt-16">
      <Card className="p-8 text-center">
        {state === "checking" && (<><Loader2 className="animate-spin mx-auto text-[#0EA5C4]" size={48} /><p className="mt-4 font-display font-bold text-lg text-[#0B2447]">Verifica pagamento…</p><p className="text-sm text-slate-500 mt-1">Attendi qualche istante.</p></>)}
        {state === "paid" && (<><CheckCircle2 className="mx-auto text-green-600" size={56} data-testid="payment-success" /><p className="mt-4 font-display font-extrabold text-2xl text-[#0B2447]">Pagamento riuscito</p><p className="text-slate-500 mt-1">Incassati {euro(amount)} con carta.</p></>)}
        {state === "cancel" && (<><XCircle className="mx-auto text-orange-500" size={56} /><p className="mt-4 font-display font-bold text-xl text-[#0B2447]">Pagamento annullato</p><p className="text-slate-500 mt-1">Il cambio è registrato ma non pagato.</p></>)}
        {(state === "failed" || state === "timeout") && (<><XCircle className="mx-auto text-red-600" size={56} /><p className="mt-4 font-display font-bold text-xl text-[#0B2447]">{state === "timeout" ? "Stato non confermato" : "Pagamento non riuscito"}</p><p className="text-slate-500 mt-1">Verifica in Pagamenti.</p></>)}
        <div className="flex gap-2 justify-center mt-6">
          <Button onClick={() => nav("/cambio")} className="bg-[#0B2447]">Nuovo Cambio</Button>
          <Button variant="outline" onClick={() => nav("/pagamenti")}>Vai ai Pagamenti</Button>
        </div>
      </Card>
    </div>
  );
}
